import Card from '@/components/Card/Card';
import styles from './LinkedBundleReview.module.css';
import { BundleDetails } from '@/types/bundles.types';
import Table from '@/components/Tables/Table/Table';
import { LinkedBundleReviewProps } from '../CreateLinkedBundles.types';

export const LinkedBundleReview = (props: LinkedBundleReviewProps) => {
  const { priceValues, linkedBundleFormValues } = props;
  const columns = [
    {
      accessorKey: 'code',
      header: 'Bundle Code',
      enableSorting: true,
    },
    {
      accessorKey: 'name',
      header: 'Display Name',
      enableSorting: true,
    },
    {
      accessorKey: 'internalName',
      header: 'Bundle Desc.',
      enableSorting: true,
    },
    {
      accessorFn: (originalRow: BundleDetails) => `$${Number(originalRow.upChargePrice).toFixed(2)}`,
      header: 'Upcharge',
    },
  ];

  return (
    <div className={styles.stepFour}>
      <div className={styles.stepFourAccordionContainer}>
        <Card>
          <h3>Linked Bundles</h3>
          <div className={styles.divider} />
          <Table
            width="calc(80vw - 250px)"
            className={styles.tableCard}
            data={priceValues.selectedBundleData}
            columns={columns}
          />
        </Card>
        <Card>
          <h3>Recommended Prices</h3>
          <div className={styles.divider} />
          <div className={styles.row}>
            <div className={styles.columnDescriptions}>
              <p>
                {`$${linkedBundleFormValues.pricePoint1}, `}
                {`$${linkedBundleFormValues.pricePoint2}, `}
                {`$${linkedBundleFormValues.pricePoint3}, `}
                {`$${linkedBundleFormValues.pricePoint4}`}
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
